import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./configMigration.html";
import { setLocalStorage, getLocalStorage, getClientId, getApiPrefixURL, getUniqueObject } from '../utils/util';
import { formatDateArrayOfObject, formatDateString } from '../utils/DateTimeUtils';
import { MIGRATION_STATUS, API_STATUS_INFO, NO_FILE_CHOSEN, ENV_TYPES, ORG_USER_INFO, LOGOUT_MESSAGES, SOURCE_LOGIN_CARD_NUMBER, TARGET_LOGIN_CARD_NUMBER, MODIFIED_ON, VALIDATION_COMPLETE, VALIDATION_ISSUES, DEPLOYMENT_ISSUES, DEPLOY_FAILURE, INVALID_CONFIG_MSG, WARNING, TAB_TITLES, ORG_TYPES } from '../utils/appConstants';
import { httpGet, httpPost, httpGetMigrateStatus } from '../services/service';
const migrateStatusColumns = [{
  label: 'Configuration Name',
  fieldName: 'name'
}, {
  label: 'Developer Name',
  fieldName: 'developerName'
}, {
  label: 'Component Type',
  fieldName: 'componentType'
}, {
  label: 'Error Message',
  fieldName: 'message'
}];
const {
  VALIDATION_FAILED,
  COMPLETED,
  MIGRATION_PARTIAL_SUCCESS,
  MIGRATION_FAILED,
  DUPLICATE_CONF,
  IMPORT_FAILED
} = MIGRATION_STATUS;
const {
  UNAUTHORIZED
} = API_STATUS_INFO;
const {
  SANDBOX,
  PRODUCTION
} = ENV_TYPES;
const {
  USER,
  ORG,
  ORG_TYPE,
  ORG_NAME
} = ORG_USER_INFO;
const {
  HEADER,
  MESSAGE,
  CONFIRM_MESSAGE,
  UPLOAD_FILE_HEADER,
  UPLOAD_FILE_MESSAGE
} = LOGOUT_MESSAGES;
const {
  CONFIGURED_ELEMENTS,
  TRANSLATIONS
} = TAB_TITLES;
const {
  SOURCE,
  TARGET
} = ORG_TYPES;
class ConfigMigration extends LightningElement {
  constructor() {
    super();
    this.isDataLoaded = false;
    this.isTargetOrgLoggedIn = false;
    this.isSourceOrgDataLoaded = false;
    this.isTargetOrgDataLoaded = false;
    this.isOrgInfoModalOpen = false;
    this.isTargetOrgInfoModalOpen = false;
    this.isFilterModalOpen = false;
    this.isConfirmModalOpen = false;
    this.isDeployedData = false;
    this.isMigrationStatusModalOpen = false;
    this.migrationsStatusTitle = VALIDATION_ISSUES;
    this.migrationStatusData = [];
    this.isSessionExpiredModalOpen = false;
    this.isLogout = false;
    this.configurations = {};
    this.orgType = null;
    this.expandedRow = null;
    this.originalConfigurations = {};
    this.statusMessage = '';
    this.envType = SANDBOX;
    this.targetTreeGridData = [];
    this.isSourceAPIExecuted = false;
    this.isTargetAPIExecuted = false;
    this.timer = void 0;
    this.migrateStatusData = [];
    this.columns = migrateStatusColumns;
    this.progressPercent = 0;
    this.migrationStatus = void 0;
    this.componentsValidationStatus = void 0;
    this.isDataTableView = true;
    this.isDataTableFilterPopup = void 0;
    this.isDataGridFilterPopup = void 0;
    this.sourceUsername = '';
    this.sourceOrganizationId = '';
    this.sourceOrganizationName = '';
    this.sourceOrganizationType = '';
    this.sourceOrgUserEmail = '';
    this.sourceOrgUserType = '';
    this.sourcePackageVersion = 0;
    this.targetUsername = '';
    this.targetOrganizationId = '';
    this.targetOrganizationName = '';
    this.targetOrganizationType = '';
    this.targetOrgUserEmail = '';
    this.targetOrgUserType = '';
    this.targetPackageVersion = 0;
    this.isSourceConfigExecuted = false;
    this.isSourceOrgLoggedIn = false;
    this.isSearchEnabled = false;
    this.isConfSelectedToExport = false;
    this.preSelectedRowsIds = [];
    this.beforeSearchRows = [];
    this.searchConfigName = '';
    this.searchDeveloperName = '';
    this.searchCompType = '';
    this.searchSubType = '';
    this.searchValue = '';
    this.filesContent = [];
    this.uploadedFileName = NO_FILE_CHOSEN;
    this.isImportFileEnabled = false;
    this.importFileUniqueID = null;
    this.isSourceOptionsEnabled = false;
    this.isTargetOptionsEnabled = false;
    this.disableTargetLoginCard = true;
    this.queuedCount = 0;
    this.deployedCount = 0;
    this.errorCount = 0;
    this.orgUserDetails = [];
    this.sourceOrgUserInfoDetails = [];
    this.targetOrgUserInfoDetails = [];
    this.isExportBtnDisabled = false;
    this.value = SANDBOX;
    this.sourceMenuOptions = [];
    this.targetMenuOptions = [];
    this.showValidateDeploySpinner = false;
    this.isSourceOrgLogout = false;
    this.logoutModalHeader = '';
    this.logoutModalMessage = '';
    this.logoutModalConfirmMessage = '';
    this.filterConfigs = [];
    this.translations = [];
    this.isConfExported = false;
    this.isConfSelectedToExport = false;
    this.isTabChange = false;
    this.warningText = WARNING;
    this.selectedType = CONFIGURED_ELEMENTS;
    this.previousTabValue = CONFIGURED_ELEMENTS;
    this.activeTabValue = CONFIGURED_ELEMENTS;
    this.configElementsTabTitle = CONFIGURED_ELEMENTS;
    this.translationsTabTitle = TRANSLATIONS;
    this.translationLanguages = [];
    this.isTargetPackageVersionLower = false;
    this.showValidateDeployProgressbar = () => {
      this.showValidateDeploySpinner = true;
      if (this.template.querySelector('my-target-tabset')) {
        this.template.querySelector('my-target-tabset').updateImportFileValue(this.isImportFileEnabled, this.importFileUniqueID);
      }
    };
    this.hideValidateDeployProgressbar = () => {
      this.showValidateDeploySpinner = false;
    };
    this.handleValidationError = event => {
      const {
        detail
      } = event;
      this.migrationsStatusTitle = VALIDATION_ISSUES;
      if (this.template.querySelector('my-toast-message')) {
        this.template.querySelector('my-toast-message').openToastErrorMessage(detail);
      }
      this.hideValidateDeployProgressbar();
    };
    this.handleMigrateError = event => {
      const {
        detail
      } = event;
      const {
        message,
        validationMessageList,
        uniqueValidationMessageList
      } = detail;
      this.migrationsStatusTitle = message === DEPLOY_FAILURE ? DEPLOYMENT_ISSUES : VALIDATION_ISSUES;
      const toastMessageRef = this.template.querySelector('my-toast-message');
      if (toastMessageRef) {
        this.migrationStatusData = validationMessageList;
        toastMessageRef.openToastErrorMessage(message);
      }
      const targetTabsetRef = this.template.querySelector('my-target-tabset');
      if (targetTabsetRef && validationMessageList && validationMessageList.length > 0 && message !== DEPLOY_FAILURE) {
        targetTabsetRef.updateQueuedData(uniqueValidationMessageList, this.migrationStatusData, this.targetTreeGridData);
      }
    };
    this.handleMigrateComplete = event => {
      const {
        detail: {
          message,
          status
        }
      } = event;
      if (message === VALIDATION_COMPLETE) {
        if (this.template.querySelector('my-target-tabset')) {
          this.template.querySelector('my-target-tabset').updateQueuedItemsForValidationSuccess(this.targetTreeGridData);
        }
        ;
      } else if (status === COMPLETED && this.targetTreeGridData && this.targetTreeGridData.length === 0) {
        if (this.template.querySelector('my-source-data-table')) {
          this.template.querySelector('my-source-data-table').updateSelectedDepRows();
        }
        if (this.template.querySelector('my-translations')) {
          this.template.querySelector('my-translations').updateSelectedTranslations();
        }
      }
      if (this.template.querySelector('my-toast-message')) {
        this.template.querySelector('my-toast-message').closeToastErrorMessage();
        this.template.querySelector('my-toast-message').openToastMessage(message);
      }
      setTimeout(() => {
        if (this.template.querySelector('my-toast-message')) {
          this.template.querySelector('my-toast-message').closeToastMessage();
        }
      }, 3000);
    };
    this.showErrorModal = event => {
      this.isMigrationStatusModalOpen = true;
      if (this.template.querySelector('my-error-modal')) {
        this.template.querySelector('my-error-modal').isModalOpen = true;
      }
    };
    this.handleClearQueuedList = () => {
      this.preSelectedRowsIds = [];
      this.targetTreeGridData = [];
      if (this.template.querySelector('my-source-data-table')) {
        this.template.querySelector('my-source-data-table').updateSelectedDepRows();
      }
    };
    this.handleRemoveTargetRecord = event => {
      const {
        detail: id
      } = event;
      this.targetTreeGridData = this.targetTreeGridData.filter(item => item.id !== id);
      this.preSelectedRowsIds = this.getPreSelectedRows();
      if (this.template.querySelector('my-source-data-table')) {
        this.template.querySelector('my-source-data-table').updateDepRowsAfterRemoveTargetRecord(this.targetTreeGridData);
      }
    };
    this.handleSourcePropertiesModal = event => {
      const {
        detail: {
          isModalOpen
        }
      } = event;
      this.isOrgInfoModalOpen = isModalOpen;
      if (this.template.querySelector('my-properties-modal')) {
        this.template.querySelector('my-properties-modal').isModalOpen = true;
        this.template.querySelector('my-properties-modal').modalTitle = 'Source Properties';
      }
      this.orgUserDetails = this.formatOrgUserInfo(this.sourceOrgUserInfoDetails);
    };
    this.handleTargetPropertiesModal = event => {
      const {
        detail: {
          isModalOpen
        }
      } = event;
      this.isOrgInfoModalOpen = isModalOpen;
      if (this.template.querySelector('my-properties-modal')) {
        this.template.querySelector('my-properties-modal').isModalOpen = true;
        this.template.querySelector('my-properties-modal').modalTitle = 'Destination Properties';
      }
      this.orgUserDetails = this.formatOrgUserInfo(this.targetOrgUserInfoDetails);
    };
    this.formatOrgUserInfo = orgUserInfoDetails => {
      let tempArray = [];
      const {
        organizationId,
        organizationType,
        organizationName,
        userInfo: {
          username
        }
      } = orgUserInfoDetails;
      tempArray = [{
        label: USER,
        value: username
      }, {
        label: ORG,
        value: organizationId
      }, {
        label: ORG_NAME,
        value: organizationName
      }, {
        label: ORG_TYPE,
        value: organizationType
      }];
      return tempArray;
    };
    this.handleFileOptionChange = event => {
      this.envType = event.detail.value;
      this.template.querySelector('lightning-button[data-my-id="sourceOrgButton"]').disabled = true;
      this.template.querySelector('lightning-button[data-my-id="sourceOrgButton"]').style.background = '#c9c7c5';
      this.template.querySelector('lightning-button[data-my-id="sourceOrgButton"]').style.border = 0;
      this.template.querySelector('input[data-my-id="uploadFile"]').disabled = false;
      this.template.querySelector('lightning-radio-group[data-my-id="sourceOrgRadioButton"]').value = null;
    };
    this.handleChange = event => {
      this.envType = event.detail.value;
      if (this.template.querySelector('lightning-button[data-my-id="sourceOrgButton"]') !== null) {
        this.template.querySelector('lightning-button[data-my-id="sourceOrgButton"]').disabled = false;
        this.template.querySelector('lightning-button[data-my-id="sourceOrgButton"]').style.background = '#0070d2';
        this.template.querySelector('input[data-my-id="uploadFile"]').disabled = true;
        this.uploadedFileName = NO_FILE_CHOSEN;
        this.template.querySelector('lightning-button[data-my-id="displayConfigurations"]').disabled = true;
        this.template.querySelector('lightning-radio-group[data-my-id="uploadFileRadioButton"]').value = null;
      }
    };
    this.getOrgInfoDetails = (orgInfo, envType) => {
      const {
        organizationId,
        packageVersion,
        userInfo: {
          username
        }
      } = orgInfo;
      if (envType === SOURCE) {
        this.sourceUsername = username;
        this.sourceOrganizationId = organizationId;
        this.sourcePackageVersion = packageVersion;
      }
      if (envType === TARGET) {
        this.targetUsername = username;
        this.targetOrganizationId = organizationId;
        this.targetPackageVersion = packageVersion;
      }
    };
    this.hanldeSelectedview = event => {
      if (event.detail === 'TreeGrid') {
        this.isDataTableView = false;
      } else {
        this.isDataTableView = true;
      }
    };
    this.getSalesforceSession = event => {
      const cardNumber = event.detail.cardNumber;
      this.envType = event.detail.envType;
      if (cardNumber === SOURCE_LOGIN_CARD_NUMBER) {
        this.orgType = SOURCE;
      }
      if (cardNumber === TARGET_LOGIN_CARD_NUMBER) {
        this.orgType = TARGET;
      }
      const salesforceUrl = this.envType === PRODUCTION ? 'https://login.salesforce.com' : 'https://test.salesforce.com';
      const hostName = window.location.hostname;
      const clientId = getClientId(hostName);
      const loginUrl = `${salesforceUrl}/services/oauth2/authorize?response_type=token&client_id=${escape(clientId)}&redirect_uri=${window.location.origin}/oauth_redirect.html&prompt=login%20consent`;
      console.log(`loginUrl :: ${loginUrl}`);
      // -- loginUrl opens in popup window
      const centerLeft = (window.screen.availWidth - 1000) / 2;
      const centerTop = (window.screen.availHeight - 800) / 2 - 50;
      window.open(loginUrl, 'demo_win', `width=1000 ,height=750,left=${centerLeft},top=${centerTop}`);
      window.addEventListener('storage', () => {
        if (!this.isSourceAPIExecuted && localStorage.getItem('sourceSessionInfo') && this.orgType === SOURCE) {
          this.getOAuthCallbackResponse();
          this.isSourceAPIExecuted = true;
        } else if (!this.isTargetAPIExecuted && localStorage.getItem('targetSessionInfo') && this.orgType === TARGET) {
          this.getOAuthCallbackResponse();
          this.isTargetAPIExecuted = true;
        }
      });
    };
    this.getOAuthCallbackResponse = () => {
      let selectedOrgType = this.orgType;
      const localThisState = this;
      let storedSessionInfo;
      if (selectedOrgType === SOURCE) {
        this.isSourceOrgDataLoaded = true;
        storedSessionInfo = JSON.parse(getLocalStorage('sourceSessionInfo'));
      }
      if (selectedOrgType === TARGET) {
        this.isTargetOrgDataLoaded = true;
        storedSessionInfo = JSON.parse(getLocalStorage('targetSessionInfo'));
      }
      const sforceSessionInfo = `{"acessToken":"${storedSessionInfo.access_token}","serviceEndpoint":"${storedSessionInfo.instance_url}/services/Soap/u/41.0/", "orgType": "${selectedOrgType}"}`;
      httpGet(`${getApiPrefixURL()}/svmx/a360/sfdc/getOrgUserInfo`, sforceSessionInfo).then(function (data) {
        const parsedData = JSON.parse(data.entity);
        const orgUserInfoResponse = parsedData.data;
        const {
          organizationId,
          packageVersion,
          userInfo: {
            username
          }
        } = orgUserInfoResponse;
        if (selectedOrgType === SOURCE) {
          localThisState.isSourceOrgLoggedIn = true;
          localThisState.isDataLoaded = true;
          localThisState.isSourceOptionsEnabled = true;
          localThisState.sourceOrgUserInfoDetails = orgUserInfoResponse;
          localThisState.sourceUsername = username;
          localThisState.sourceOrganizationId = organizationId;
          localThisState.sourcePackageVersion = packageVersion;
          localThisState.disableTargetLoginCard = false;
          localThisState.isExportBtnDisabled = false;
          localThisState.sourceMenuOptions = localThisState.orgMenuOptions();
          localThisState.isSourceAPIExecuted = false;
        }
        if (selectedOrgType === TARGET) {
          localThisState.targetPackageVersion = packageVersion;
          if (Math.trunc(localThisState.targetPackageVersion) < Math.trunc(localThisState.sourcePackageVersion)) {
            localThisState.isTargetPackageVersionLower = true;
            return;
          } else if (data.status === 401 && data.statusInfo === UNAUTHORIZED) {
            localThisState.isSessionExpiredModalOpen = true;
          } else {
            localThisState.isTargetOrgLoggedIn = true;
            localThisState.targetOrgUserInfoDetails = orgUserInfoResponse;
            localThisState.targetUsername = username;
            localThisState.targetOrganizationId = organizationId;
            localThisState.isTargetOptionsEnabled = true;
            localThisState.isTargetAPIExecuted = false;
            localThisState.targetMenuOptions = localThisState.orgMenuOptions();
          }
        }
        if (selectedOrgType === SOURCE) {
          setLocalStorage('sourceOrganizationInfo', orgUserInfoResponse);
        } else {
          setLocalStorage('targetOrganizationInfo', orgUserInfoResponse);
        }
      }).catch(function (err) {
        console.log('Fetching OrgUserInfo failed due to error:', err);
      }).finally(() => {
        if (selectedOrgType === TARGET) {
          localThisState.isTargetOrgDataLoaded = false;
        }
      });
      this.getConfigurations(selectedOrgType, sforceSessionInfo);
    };
    this.getConfigurations = (selectedOrgType, sforceSessionInfo) => {
      const localThisState = this;
      if (selectedOrgType === SOURCE) {
        let apiUrl = `${getApiPrefixURL()}/svmx/a360/migration/getConfigurations`;
        if (!this.isDataTableView) {
          apiUrl = `${getApiPrefixURL()}/svmx/a360/migration/getConfigurationsTreeView`;
        }
        httpGet(apiUrl, sforceSessionInfo, null).then(data => {
          if (data.status === 401 && data.statusInfo === UNAUTHORIZED) {
            this.isSessionExpiredModalOpen = true;
          } else {
            const parsedData = JSON.parse(data.entity);
            let formattedData = [];
            let formattedTranslationData = [];
            if (localThisState.isDataTableView) {
              formattedData = localThisState.formatConfigurations(parsedData.data);
              formattedTranslationData = localThisState.formatTranslationConfigurations(parsedData.data);
            } else {
              formattedData = localThisState.formattedConfigurations(parsedData.data);
              localThisState.expandedRow = [formattedData[0].id];
            }
            const formatedConfigs = formatDateArrayOfObject(formattedData, MODIFIED_ON);
            localThisState.configurations = formatedConfigs;
            localThisState.originalConfigurations = formatedConfigs;
            localThisState.translations = formattedTranslationData;
            localThisState.activeTabValue = CONFIGURED_ELEMENTS;
          }
          this.envType = SANDBOX;
        }).catch(err => {
          console.log('Fetching Configurations failed due to error: ', err);
        }).finally(() => {
          this.isImportFileEnabled = false;
          if (selectedOrgType === SOURCE) {
            this.isSourceOrgDataLoaded = false;
            this.isTargetOrgDataLoaded = false;
          } else {
            this.isTargetOrgDataLoaded = false;
          }
        });
      }
    };
    this.formatTranslationConfigurations = data => {
      let tempTranslations = [];
      let langArray = [];
      let translationMap = new Map();
      let translationConfigMap = new Map();
      let translationModifiedOnMap = new Map();
      let translationModifiedByMap = new Map();
      for (let index = 0; index < data.length; index++) {
        const {
          componentType,
          name,
          modifiedBy,
          modifiedOn
        } = data[index];
        let {
          translationConfigurations
        } = data[index];
        if (componentType == TRANSLATIONS) {
          let modifiedName = name;
          if (modifiedName) {
            modifiedName = modifiedName.split('-')[0];
            if (translationMap.get(modifiedName) == undefined) {
              translationMap.set(modifiedName, new Array());
              translationConfigMap.set(modifiedName, new Array());
              translationModifiedOnMap.set(modifiedName, new Array());
              translationModifiedByMap.set(modifiedName, new Array());
            }
            translationMap.get(modifiedName).push(translationConfigurations);
            translationConfigMap.get(modifiedName).push(data[index]);
            if (modifiedOn) {
              translationModifiedOnMap.get(modifiedName).push(modifiedOn);
            }
            if (modifiedBy) {
              translationModifiedByMap.get(modifiedName).push(modifiedBy);
            }
            if (!langArray.includes(modifiedName)) {
              langArray.push(modifiedName);
            }
          }
        }
      }
      this.translationLanguages = langArray.sort();
      let count = 1;
      for (let index = 0; index < this.translationLanguages.length; index++) {
        let languageName = this.translationLanguages[index];
        const translationConfigs = translationMap.get(languageName).flat();
        const translationsFormattedRow = {
          name: languageName,
          languageCount: translationConfigs.length,
          id: count,
          translationConfigurations: translationConfigMap.get(languageName),
          modifiedBy: translationModifiedByMap.get(languageName) && translationModifiedByMap.get(languageName).length > 0 ? translationModifiedByMap.get(languageName).sort()[0] : null,
          modifiedOn: translationModifiedOnMap.get(languageName) && translationModifiedOnMap.get(languageName).length > 0 ? formatDateString(translationModifiedOnMap.get(languageName).sort().reverse()[0]) : null
        };
        tempTranslations.push(translationsFormattedRow);
        count++;
      }
      return tempTranslations;
    };
    this.formatConfigurations = data => {
      let tempArray = [];
      for (let index = 0; index < data.length; index++) {
        let dependencyCellData = '';
        const {
          componentType,
          configType,
          componentName,
          createdOn,
          developerName,
          id,
          modifiedOn,
          name,
          createdBy,
          modifiedBy,
          tags
        } = data[index];
        let {
          dependencies
        } = data[index];
        if (dependencies && dependencies.length > 0) {
          dependencies = formatDateArrayOfObject(dependencies, MODIFIED_ON);
          dependencyCellData = dependencies.length + ' - Review';
        }
        const formattedRow = {
          componentType,
          configType,
          componentName,
          createdOn,
          developerName,
          id,
          modifiedOn,
          name,
          dependencies,
          dependencyCellData,
          createdBy,
          modifiedBy,
          tags
        };
        if (componentType !== TRANSLATIONS) {
          tempArray.push(formattedRow);
        }
      }
      return tempArray;
    };
    /* TODO: VKV and EK - Relook at the unique id generation logic */
    this.formattedConfigurations = data => {
      for (let index = 0; index < data.length; index++) {
        const {
          name,
          _children
        } = data[index];
        if (_children === undefined || _children.length > 0) {
          const levelOneChild = _children === undefined ? null : _children;
          const tempData = {
            name,
            'developerName': '-',
            'id': Math.floor(Math.random() * Math.floor(Math.random() * Date.now())),
            '_children': levelOneChild
          };
          if (_children !== undefined && _children.length > 0) {
            for (let childIndex = 0; childIndex < _children.length; childIndex++) {
              const {
                name,
                _children: childTwo
              } = _children[childIndex];
              if (childTwo === undefined || childTwo.length > 0) {
                const levelTwoChild = childTwo === undefined ? '' : childTwo;
                let childTwoData = {
                  name,
                  'developerName': '-',
                  'id': Math.floor(Math.random() * Math.floor(Math.random() * Date.now())),
                  '_children': levelTwoChild
                };
                if (childTwo === undefined) {
                  childTwoData = {
                    name,
                    'developerName': '-',
                    'id': Math.floor(Math.random() * Math.floor(Math.random() * Date.now()))
                  };
                }
                _children[childIndex] = childTwoData;
              }
            }
          }
          data[index] = tempData;
        }
      }
      return data;
    };
    this.logoutSourceOrg = () => {
      const localThisState = this;
      localThisState.isSourceOrgLogout = true;
      localThisState.logoutModalHeader = HEADER;
      localThisState.logoutModalMessage = MESSAGE;
      localThisState.logoutModalConfirmMessage = CONFIRM_MESSAGE;
    };
    this.cancelSourceOrgDisconnect = () => {
      this.isSourceOrgLogout = false;
    };
    this.closePackageVersionWarnModal = () => {
      const localThisState = this;
      localStorage.removeItem('targetSessionInfo');
      localThisState.isTargetPackageVersionLower = false;
      localThisState.isTargetOrgDataLoaded = false;
      localThisState.isTargetAPIExecuted = false;
    };
    this.handleSourceOrgDisconnect = () => {
      if (!this.isImportFileEnabled) {
        this.isSourceOrgLogout = false;
        this.logoutOrg(SOURCE);
        if (this.isTargetOptionsEnabled) {
          this.logoutOrg(TARGET);
        } else {
          this.disableTargetLoginCard = true;
        }
      } else {
        this.isSourceOrgLogout = false;
        this.logoutFileTargetOrg();
      }
    };
    this.logoutTargetOrg = () => {
      this.logoutOrg(TARGET);
    };
    this.openSourceOrgUserInfoModal = () => {
      this.isOrgInfoModalOpen = true;
    };
    this.closeSourceOrgUserInfoModal = () => {
      this.isOrgInfoModalOpen = false;
    };
    this.openTargetOrgUserInfoModal = () => {
      this.isTargetOrgInfoModalOpen = true;
    };
    this.closeTargetOrgUserInfoModal = () => {
      this.isTargetOrgInfoModalOpen = false;
    };
    this.closeSourceOrgLoginModal = () => {
      this.isSourceOrgLoggedIn = false;
    };
    this.toBase64 = file => new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        let result = reader.result;
        let base64 = 'base64,';
        let content = result.indexOf(base64) + base64.length;
        let fileContents = result.substring(content);
        resolve(fileContents);
      };
      reader.onerror = error => reject(error);
    });
    this.handleDisplayConfigurations = () => {
      const localThisState = this;
      this.isSourceOrgDataLoaded = true;
      httpPost(`${getApiPrefixURL()}/svmx/a360/migration/importFile`, null, null, this.filesContent).then(function (data) {
        const response = JSON.parse(data.entity);
        const {
          message,
          success,
          data: uniqueID
        } = response;
        if (!success) {
          localThisState.statusMessage = message;
          localThisState.isImportFileEnabled = false;
          localThisState.isSourceOrgDataLoaded = false;
          if (localThisState.template.querySelector('my-toast-message')) {
            localThisState.template.querySelector('my-toast-message').openToastErrorMessage(localThisState.statusMessage, true);
          }
          setTimeout(() => {
            if (localThisState.template.querySelector('my-toast-message')) {
              localThisState.template.querySelector('my-toast-message').closeToastMessage();
            }
          }, 3000);
          return;
        }
        localThisState.importFileUniqueID = uniqueID;
        httpGet(`${getApiPrefixURL()}/svmx/a360/migration/getConfigurations`, null, uniqueID).then(res => {
          const parsedData = JSON.parse(res.entity);
          const {
            message,
            success,
            data
          } = parsedData;
          if (data && data.length === 0) {
            localThisState.isImportFileEnabled = false;
            localThisState.isSourceOrgDataLoaded = false;
            localThisState.template.querySelector('my-toast-message').openToastErrorMessage(INVALID_CONFIG_MSG, true);
            return;
          }
          if (!success) {
            localThisState.statusMessage = message;
            localThisState.isSourceOrgDataLoaded = false;
            if (localThisState.template.querySelector('my-toast-message')) {
              localThisState.template.querySelector('my-toast-message').openToastErrorMessage(localThisState.statusMessage);
            }
            setTimeout(() => {
              if (localThisState.template.querySelector('my-toast-message')) {
                localThisState.template.querySelector('my-toast-message').closeToastMessage();
              }
            }, 3000);
            return;
          }
          let formattedData = localThisState.getFormattedResponse(data);
          const dateFormattedConfigs = formatDateArrayOfObject(formattedData, MODIFIED_ON);
          localThisState.configurations = dateFormattedConfigs;
          localThisState.originalConfigurations = dateFormattedConfigs;
          localThisState.translations = localThisState.formatTranslationConfigurations(data);
          localThisState.isSourceOrgLoggedIn = false;
          localThisState.isDataLoaded = true;
          localThisState.isImportFileEnabled = true;
          localThisState.isSourceOrgDataLoaded = false;
          localStorage.setItem('sourceSessionInfo', JSON.stringify(localThisState.uploadedFileName));
          localThisState.disableTargetLoginCard = false;
          localThisState.isExportBtnDisabled = true;
          localThisState.isSourceOptionsEnabled = true;
          localThisState.sourceMenuOptions = localThisState.importFileMenuOptions();
        }).catch(function (err) {
          console.log('fecthing configurations failed - Error', err);
        }).finally(() => {
          console.log('configurations fetched successfully');
        });
      }).catch(function (err) {
        console.log('display configurations - Error', err);
        if (err.status === 403) {
          localThisState.isImportFileEnabled = false;
          localThisState.isSourceOrgDataLoaded = false;
          localThisState.template.querySelector('my-toast-message').openToastErrorMessage('Invalid or corrupted file.', true);
          return;
        }
      }).finally(() => {
        console.log('displayed configurations successfully');
      });
    };
    this.getFormattedResponse = data => {
      let counter = 0;
      let tempArray = [];
      const configIdMap = new Map();
      for (let index = 0; index < data.length; index++) {
        let dependencyCellData = '';
        let formattedDep = [];
        counter = +index;
        const {
          id,
          name,
          developerName,
          configType,
          componentType,
          componentName,
          modifiedOn,
          modifiedBy,
          tags
        } = data[index];
        let {
          dependencies
        } = data[index];
        const configId = id ? id : counter.toString();
        configIdMap.set(developerName, configId);
        if (dependencies && dependencies.length > 0) {
          formattedDep = this.formatDepResponseForUploadFile(dependencies, configIdMap);
          dependencies = formatDateArrayOfObject(formattedDep, MODIFIED_ON);
          dependencyCellData = dependencies.length + ' - Review';
        }
        const formattedResponse = {
          'id': configId,
          name,
          developerName,
          configType,
          componentType,
          componentName,
          dependencies: formattedDep,
          dependencyCellData,
          modifiedOn,
          modifiedBy,
          tags
        };
        if (componentType !== TRANSLATIONS) {
          tempArray.push(formattedResponse);
        }
      }
      return tempArray;
    };
    this.formatDepResponseForUploadFile = (dependencies, configIdMap) => {
      if (dependencies && dependencies.length > 0) {
        for (let index = 0; index < dependencies.length; index++) {
          const {
            id,
            name,
            developerName,
            configType,
            componentType,
            componentName,
            modifiedOn
          } = dependencies[index];
          const formattedDepResponse = {
            'id': id ? id : configIdMap.get(developerName),
            name,
            developerName,
            configType,
            componentType,
            componentName,
            modifiedOn
          };
          dependencies[index] = formattedDepResponse;
        }
        return dependencies;
      }
    };
    this.handleBackButton = () => {
      const localThisState = this;
      if (localThisState.isTargetOptionsEnabled) {
        localThisState.isSourceOrgLogout = true;
        localThisState.logoutModalHeader = UPLOAD_FILE_HEADER;
        localThisState.logoutModalMessage = UPLOAD_FILE_MESSAGE;
      } else {
        localThisState.clearUploadFileData();
      }
    };
    this.logoutFileTargetOrg = () => {
      const localThisState = this;
      localThisState.clearUploadFileData();
      if (localThisState.isTargetOptionsEnabled) {
        localThisState.logoutOrg(TARGET);
      }
    };
    this.clearUploadFileData = () => {
      const localThisState = this;
      localThisState.configurations = {};
      localThisState.originalConfigurations = {};
      localThisState.isImportFileEnabled = false;
      localThisState.isDataLoaded = false;
      localThisState.targetTreeGridData = undefined;
      localThisState.isSourceOrgLoggedIn = false;
      localThisState.isSourceConfigExecuted = false;
      localThisState.isSourceOptionsEnabled = false;
      localThisState.disableTargetLoginCard = true;
      localThisState.sourcePackageVersion = 0;
      localThisState.targetPackageVersion = 0;
      localThisState.sourceMenuOptions = [];
      localStorage.removeItem('sourceOrganizationInfo');
      localStorage.removeItem('sourceSessionInfo');
      localThisState.template.querySelector('my-panel-header').enableOptions = false;
    };
    this.logoutOrg = orgType => {
      const localThisState = this;
      if (orgType === SOURCE) {
        localThisState.isSourceOrgLoggedIn = false;
        localThisState.isSourceConfigExecuted = false;
        localThisState.isSourceOrgDataLoaded = true;
        localThisState.isLogout = true;
        localThisState.isSourceOptionsEnabled = false;
        localThisState.disableTargetLoginCard = true;
        localThisState.sourceMenuOptions = [];
        localThisState.sourcePackageVersion = 0;
        localThisState.targetPackageVersion = 0;
        localThisState.template.querySelector('my-panel-header').enableOptions = false;
      } else if (orgType === TARGET) {
        localThisState.isTargetOrgDataLoaded = true;
        localThisState.isTargetOptionsEnabled = false;
        localThisState.isTargetOrgLoggedIn = false;
        localThisState.isLogout = true;
        localThisState.targetMenuOptions = [];
        localThisState.targetPackageVersion = 0;
        localThisState.template.querySelector('my-panel-header').enableOptions = false;
      }
      /* localThisState.envType = SANDBOX; */
      let storedSessionInfo;
      if (orgType === SOURCE && JSON.parse(getLocalStorage('sourceSessionInfo'))) {
        storedSessionInfo = JSON.parse(getLocalStorage('sourceSessionInfo'));
      } else {
        if (JSON.parse(getLocalStorage('targetSessionInfo'))) storedSessionInfo = JSON.parse(getLocalStorage('targetSessionInfo'));
      }
      const sforceSessionInfo = `{"acessToken":"${storedSessionInfo.access_token}","serviceEndpoint":"${storedSessionInfo.instance_url}/services/Soap/u/41.0/"}`;
      httpGet(`${getApiPrefixURL()}/svmx/a360/sfdc/logout`, sforceSessionInfo).then(function (data) {
        if (data.status === 200) {
          if (orgType === SOURCE) {
            localStorage.removeItem('sourceOrganizationInfo');
            localStorage.removeItem('sourceSessionInfo');
            localThisState.isSourceOrgDataLoaded = false;
          } else if (orgType === TARGET) {
            localStorage.removeItem('targetOrganizationInfo');
            localStorage.removeItem('targetSessionInfo');
            localThisState.isTargetOrgDataLoaded = false;
          }
          localThisState.handleClearQueuedList();
        }
      }).catch(function (err) {
        console.log('logout - Error', err);
      }).finally(() => {});
    };
    this.handleSearch = event => {
      if (this.isDataTableView) {
        this.handleSourceDataTableSearch(event);
      } else {
        this.handleSourceTreeGridSearch(event, null);
      }
    };
    this.handleUpdateTargetTableData = () => {
      const localThisState = this;
      const targetTabsetRef = localThisState.template.querySelector('my-target-tabset');
      if (targetTabsetRef) {
        const formattedDetails = localThisState.formattedDetails(localThisState.targetTreeGridData);
        if (formattedDetails) {
          targetTabsetRef.updateQueuedCount(formattedDetails, true);
        }
      }
    };
    this.handleFilterConfigurations = event => {
      const filterConfigData = event.detail;
      this.filterConfigs = filterConfigData;
      this.preSelectedRowsIds = this.getPreSelectedRows();
      if (filterConfigData && filterConfigData.length === 0) {
        this.configurations = this.originalConfigurations;
      }
    };
    this.handleSourceDataTableSearch = event => {
      const localThisState = this;
      let searchValue = event === null ? filterValue : event.detail;
      localThisState.isSearchEnabled = true;
      const filterConfigs = localThisState.filterConfigs;
      let tempConfigurations = filterConfigs && filterConfigs.length > 0 ? filterConfigs : localThisState.originalConfigurations;
      const sourceDataTableRef = localThisState.template.querySelector('my-source-data-table');
      if (searchValue.length > 2) {
        searchValue = searchValue.toLowerCase();
        localThisState.searchValue = searchValue;
        sourceDataTableRef.searchEnabled(true);
        if (tempConfigurations) {
          tempConfigurations = tempConfigurations.filter(item => item.name && item.name.toLowerCase().includes(searchValue) || item.developerName && item.developerName.toLowerCase().includes(searchValue) || item.componentName && item.componentName.toLowerCase().includes(searchValue));
        }
      } else if (searchValue.length === 0) {
        tempConfigurations = filterConfigs && filterConfigs.length > 0 ? filterConfigs : localThisState.originalConfigurations;
        if (sourceDataTableRef) {
          sourceDataTableRef.data = localThisState.originalConfigurations;
          sourceDataTableRef.searchConfigName = '';
          sourceDataTableRef.searchDeveloperName = '';
          if (filterConfigs && filterConfigs.length === 0) {
            sourceDataTableRef.disableFilterIcon();
          }
          sourceDataTableRef.searchEnabled(false);
        }
        localThisState.isSearchEnabled = false;
      }
      localThisState.beforeSearchRows = localThisState.targetTreeGridData !== undefined ? [...localThisState.targetTreeGridData] : [];
      localThisState.preSelectedRowsIds = localThisState.getPreSelectedRows();
      localThisState.configurations = tempConfigurations;
    };
    this.getPreSelectedRows = () => {
      const selectedRowsIds = [];
      const targetData = this.targetTreeGridData;
      if (targetData !== undefined && targetData !== null) {
        for (let index = 0; index < targetData.length; index++) {
          const {
            id
          } = targetData[index];
          selectedRowsIds.push(id);
        }
      }
      return selectedRowsIds;
    };
    this.updateSourceTableRows = event => {
      const localThisState = this;
      localThisState.targetTreeGridData = event.detail;
      localThisState.preSelectedRowsIds = localThisState.getPreSelectedRows();
      const sourceDataTableRef = localThisState.template.querySelector('my-source-data-table');
      if (sourceDataTableRef) {
        sourceDataTableRef.updatePreviousSelectedRows(event.detail);
      }
    };
    this.handleSourceTreeGridSearch = (event, filterValue) => {
      let searchValue = event === null ? filterValue : event.currentTarget.value;
      if (searchValue !== null) {
        searchValue = searchValue.toLowerCase();
      }
      let tempConfigurations = this.configurations;
      let firstLevelFilteredData;
      if (searchValue !== "") {
        if (tempConfigurations !== undefined) {
          tempConfigurations = this.getFilteredData(this.originalConfigurations, searchValue, 'parent');
          if (tempConfigurations !== undefined && tempConfigurations.length > 0) {
            this.expandedRow = [tempConfigurations[0].name];
          }
          if (tempConfigurations !== undefined && tempConfigurations.length === 0) {
            this.originalConfigurations.filter(element => {
              firstLevelFilteredData = this.getFilteredData(element._children, searchValue, 'levelOne');
              if (firstLevelFilteredData !== undefined && firstLevelFilteredData.length > 0) {
                tempConfigurations = firstLevelFilteredData;
                this.expandedRow = [tempConfigurations[0].name];
              }
            });
          }
          if (firstLevelFilteredData !== undefined && firstLevelFilteredData.length === 0) {
            this.originalConfigurations.filter(element => {
              element._children.filter(item => {
                const secondLevelFilteredData = this.getFilteredData(item._children, searchValue, 'levelTwo');
                if (secondLevelFilteredData !== undefined && secondLevelFilteredData.length > 0) {
                  tempConfigurations = secondLevelFilteredData;
                }
              });
            });
          }
          this.configurations = tempConfigurations;
        }
      } else {
        this.configurations = this.originalConfigurations;
        this.expandedRow = [this.configurations[0].name];
      }
    };
    this.getFilteredData = (originalConfig, searchValue, level) => {
      let filteredData;
      if (originalConfig !== undefined) {
        filteredData = originalConfig.filter(item => level === 'parent' || level === 'levelOne' ? item.name.toLowerCase().includes(searchValue) : this.getSecondLevelFilteredData(item, searchValue));
      }
      return filteredData;
    };
    this.getSecondLevelFilteredData = (secondLevelData, searchValue) => {
      let secondLevelFilteredData = {};
      if (secondLevelData !== undefined) {
        secondLevelFilteredData = secondLevelData.name.toLowerCase().includes(searchValue) || secondLevelData.developerName.toLowerCase().includes(searchValue);
      }
      return secondLevelFilteredData;
    };
    this.applySearchFilterOnDataTable = () => {
      this.isSearchEnabled = true;
      const searchInput = this.template.querySelector('input[data-my-id="sourceTreeGridSearchInput"]');
      const configurationName = this.template.querySelector('input[data-my-id="configurationName"]').value;
      const developerName = this.template.querySelector('input[data-my-id="developerName"]').value;
      const compType = this.template.querySelector('input[data-my-id="compType"]').value;
      const compSubType = this.template.querySelector('input[data-my-id="compSubType"]').value;
      const filterValues = [configurationName, developerName, compType, compSubType];
      const searchfFilterValue = [];
      for (let index = 0; index < filterValues.length; index++) {
        if (filterValues[index] !== "") {
          searchfFilterValue.push(filterValues[index]);
        }
      }
      searchInput.value = searchfFilterValue.join(", ");
      const tempConfigurations = this.configurations.filter(item => item.name.toLowerCase().includes(configurationName.toLowerCase()) && item.developerName.toLowerCase().includes(developerName.toLowerCase()) && item.configType.toLowerCase().includes(compType.toLowerCase()) && item.componentType.toLowerCase().includes(compSubType.toLowerCase()));
      this.beforeSearchRows = this.targetTreeGridData !== undefined ? [...this.targetTreeGridData] : [];
      this.preSelectedRowsIds = this.getPreSelectedRows();
      this.configurations = tempConfigurations;
      this.searchConfigName = configurationName;
      this.searchDeveloperName = developerName;
      this.searchCompType = compType;
      this.searchSubType = compSubType;
      if (this.isDataTableFilterPopup) {
        this.isDataTableFilterPopup = false;
      }
      if (this.isDataGridFilterPopup) {
        this.isDataGridFilterPopup = false;
      }
    };
    this.applySearchFilterData = () => {
      const configurationName = this.template.querySelector('input[data-my-id="configurationName"]') !== null ? this.template.querySelector('input[data-my-id="configurationName"]').value : "";
      const modifiedBy = this.template.querySelector('input[data-my-id="modifiedBy"]') !== null ? this.template.querySelector('input[data-my-id="modifiedBy"]').value : "";

      /* const fromDate = this.template.querySelector('lightning-input[data-my-id="fromDate"]') !== undefined ? this.template.querySelector('lightning-input[data-my-id="fromDate"]') : "";
      const toDate = this.template.querySelector('lightning-input[data-my-id="toDate"]') !== undefined ? this.template.querySelector('lightning-input[data-my-id="toDate"]') : ""; */

      const searchInput = this.template.querySelector('input[data-my-id="sourceTreeGridSearchInput"]');
      if (configurationName !== "" && modifiedBy === "") {
        this.handleSourceTreeGridSearch(null, configurationName);
        searchInput.value = `${configurationName}`;
      } else if (configurationName === "" && modifiedBy !== "") {
        this.handleSourceTreeGridSearch(null, modifiedBy);
        searchInput.value = `${modifiedBy}`;
      } else if (configurationName !== "" && modifiedBy !== "") {
        this.handleFilterData(configurationName, modifiedBy);
        searchInput.value = `${configurationName},${modifiedBy}`;
      }
      if (this.isDataTableFilterPopup) {
        this.isDataTableFilterPopup = false;
      }
      if (this.isDataGridFilterPopup) {
        this.isDataGridFilterPopup = false;
      }
    };
    this.handleFilterData = (configType, modifiedBy) => {
      let tempConfigurations = this.configurations;
      let filteredData = [];
      tempConfigurations.filter(element => {
        if (element._children !== undefined) {
          element._children.filter(item => {
            if (item._children !== undefined) {
              item._children.filter(secondLevelChild => {
                if (secondLevelChild.name.includes(configType) && secondLevelChild.modifiedBy.includes(modifiedBy)) {
                  filteredData = item._children;
                }
              });
            }
          });
        }
      });
      this.configurations = filteredData;
    };
    this.getTranslationIds = translationIds => {
      let ids = [];
      for (let index = 0; index < translationIds.length; index++) {
        const {
          id
        } = translationIds[index];
        ids.push(id);
      }
      return ids;
    };
    this.handleActive = event => {
      const localThisState = this;
      const tabValue = event.target.value;
      localThisState.previousTabValue = tabValue === CONFIGURED_ELEMENTS ? TRANSLATIONS : CONFIGURED_ELEMENTS;
      if (localThisState.activeTabValue !== tabValue && localThisState.targetTreeGridData && localThisState.targetTreeGridData.length > 0) {
        localThisState.isTabChange = true;
      }
      localThisState.selectedType = localThisState.previousTabValue;
      localThisState.activeTabValue = tabValue;
      if (localThisState.isImportFileEnabled) {
        localThisState.activeTabValue = CONFIGURED_ELEMENTS;
        if (this.translations && this.translations.length > 0 && this.originalConfigurations && this.originalConfigurations.length === 0) {
          localThisState.activeTabValue = TRANSLATIONS;
        }
      }
    };
    this.handleExportConfigurations = event => {
      const {
        detail
      } = event;
      const {
        selectedTranslationRows,
        isTranslation
      } = detail || {};
      let selectedRowsData = isTranslation ? selectedTranslationRows : detail;
      if (selectedRowsData === undefined || selectedRowsData === null || selectedRowsData && selectedRowsData.length === 0) {
        this.isConfSelectedToExport = true;
        return;
      } else if (this.targetTreeGridData && this.targetTreeGridData.length > 0 && !isTranslation) {
        selectedRowsData = selectedRowsData.filter(o1 => this.targetTreeGridData.some(o2 => o1.id === o2.id));
      }
      this.isConfExported = true;
      const sourceSessionInfo = JSON.parse(getLocalStorage('sourceSessionInfo'));
      const sforceSessionInfo = `{"acessToken":"${sourceSessionInfo.access_token}","serviceEndpoint":"${sourceSessionInfo.instance_url}"}`;
      const formattedRequest = JSON.stringify({
        migrationDataList: selectedRowsData
      });
      httpPost(`${getApiPrefixURL()}/svmx/a360/migration/export`, sforceSessionInfo, null, formattedRequest).then(response => {
        if (response.status === 401 && response.statusInfo === UNAUTHORIZED) {
          this.isSessionExpiredModalOpen = true;
        } else {
          const fileResponse = response.entity;
          let fileData = [`data:image/png;base64, ${fileResponse}`];
          let downloadElement = document.createElement('a');
          downloadElement.href = fileData;
          downloadElement.download = 'configurations.zip';
          downloadElement.click();
        }
      }).catch(function (err) {
        console.log('export configuratios failed - Error', err);
      }).finally(() => {
        this.isConfExported = false;
        console.log('configuratios exported successfully');
      });
    };
    this.closeExportConfModal = () => {
      this.isConfSelectedToExport = false;
    };
    this.handleWarningModal = () => {
      const localThisState = this;
      localThisState.isTabChange = false;
      localThisState.template.querySelector('lightning-tabset[data-my-id="configelements-tabset"]').activeTabValue = localThisState.activeTabValue;
      if (this.template.querySelector('my-target-tabset')) {
        this.template.querySelector('my-target-tabset').clearQueueList();
      } else {
        localThisState.handleClearQueuedList();
      }
      if (localThisState.isImportFileEnabled) {
        localThisState.isImportFileEnabled = false;
        localThisState.activeTabValue = localThisState.previousTabValue;
      }
    };
    this.cancelWarningModal = () => {
      const localThisState = this;
      localThisState.isTabChange = false;
      localThisState.activeTabValue = localThisState.previousTabValue;
      if (localThisState.isImportFileEnabled) {
        localThisState.template.querySelector('lightning-tabset[data-my-id="configelements-tabset"]').activeTabValue = localThisState.activeTabValue;
        localThisState.isImportFileEnabled = false;
      }
    };
    this.formattedDetails = details => {
      let formattedDetailsList = [];
      if (details) {
        for (let index = 0; index < details.length; index++) {
          const {
            componentName,
            componentType,
            configType,
            createdBy,
            createdOn,
            dependencies,
            dependencyCellData,
            developerName,
            id,
            modifiedBy,
            modifiedOn,
            name,
            translationConfigurations,
            message,
            isTranslation
          } = details[index];
          const isError = true;
          const formattedList = {
            componentName,
            componentType,
            configType,
            createdBy,
            createdOn,
            dependencies,
            dependencyCellData,
            developerName,
            id,
            modifiedBy,
            modifiedOn,
            name,
            isError,
            translationConfigurations,
            message,
            isTranslation
          };
          formattedDetailsList.push(formattedList);
        }
      }
      return formattedDetailsList;
    };
    this.confirmDeploy = () => {
      this.isConfirmModalOpen = true;
    };
    this.closeConfirmModal = () => {
      this.isConfirmModalOpen = false;
    };
    this.handleSessionExpire = () => {
      const localThisState = this;
      localThisState.isSessionExpiredModalOpen = false;
      localThisState.isSourceOrgLoggedIn = false;
      localThisState.isSourceConfigExecuted = false;
      localThisState.isSourceOptionsEnabled = false;
      localThisState.disableTargetLoginCard = true;
      localThisState.sourceMenuOptions = [];
      localThisState.isTargetOptionsEnabled = false;
      localThisState.isTargetOrgLoggedIn = false;
      localThisState.isLogout = true;
      localThisState.targetMenuOptions = [];
      localThisState.template.querySelector('my-panel-header').enableOptions = false;
      localThisState.template.querySelector('my-panel-header').enableOptions = false;
      localStorage.removeItem('sourceOrganizationInfo');
      localStorage.removeItem('sourceSessionInfo');
      localStorage.removeItem('targetOrganizationInfo');
      localStorage.removeItem('targetSessionInfo');
    };
    this.handleValidateDeploySessionExpire = () => {
      const localThisState = this;
      localThisState.isSessionExpiredModalOpen = true;
      localThisState.stopMigrationStatusTimer();
      localThisState.isDeployedData = false;
      localThisState.hideValidateDeployProgressbar();
    };
    this.deploySourceOrgDataToTargetOrg = isOverwriteConfirm => {
      const localThisState = this;
      this.isDeployedData = true;
      this.isConfirmModalOpen = false;
      this.progressPercent = 0;
      localThisState.componentsValidationStatus = "";
      this.migrationStatus = "";
      let selectedRowsData = this.targetTreeGridData;
      let formattedRequest = [];
      let isValidate = isOverwriteConfirm === true ? false : true;
      let isOverwrite = isOverwriteConfirm === true ? true : false;
      const formattedMigrationOptions = {
        validate: isValidate,
        overwrite: isOverwrite
      };
      if (this.isDataTableView) {
        if (isOverwrite && localThisState.migrateStatusData.length > 0) {
          selectedRowsData = localThisState.overwriteMigrationData(selectedRowsData, localThisState.migrateStatusData);
        }
        formattedRequest = JSON.stringify({
          migrationOption: formattedMigrationOptions,
          migrationDataList: [...selectedRowsData]
        });
      } else {
        const formattedRowsRequest = this.getFormattedRequest(selectedRowsData);
        const flatRowsArray = this.getFlatArrayRequest(formattedRowsRequest);
        formattedRequest = JSON.stringify({
          migrationDataList: flatRowsArray
        });
      }
      const sourceSessionInfo = JSON.parse(getLocalStorage('sourceSessionInfo'));
      const targetSessionInfo = JSON.parse(getLocalStorage('targetSessionInfo'));
      const sforceSessionInfo = this.isImportFileEnabled ? this.importFileUniqueID : `{"acessToken":"${sourceSessionInfo.access_token}","serviceEndpoint":"${sourceSessionInfo.instance_url}"}`;
      const tforceSessionInfo = `{"acessToken":"${targetSessionInfo.access_token}","serviceEndpoint":"${targetSessionInfo.instance_url}" }`;
      const deployEndPoint = this.isImportFileEnabled ? 'import' : 'migrate';
      localThisState.template.querySelector('div[data-my-id="initialProgressBar"]').style.display = 'block';
      localThisState.template.querySelector('div[data-my-id="initialMigrationStatus"]').style.display = 'block';
      localThisState.template.querySelector('button[data-my-id="deployButton"]').disabled = true;
      httpPost(`${getApiPrefixURL()}/svmx/a360/migration/${deployEndPoint}`, sforceSessionInfo, tforceSessionInfo, formattedRequest).then(response => {
        console.log('response', response);
        if (response.status === 401 && response.statusInfo === UNAUTHORIZED) {
          this.isSessionExpiredModalOpen = true;
          this.stopMigrationStatusTimer();
          this.isDeployedData = false;
        } else {
          const parsedData = JSON.parse(response.entity);
          const {
            data: migrateResponse,
            success,
            message
          } = parsedData;
          if (success) {
            const {
              jobId
            } = migrateResponse;
            this.timer = setInterval(() => {
              console.log("Migrate Status in every 1 seconds :: ");
              httpGetMigrateStatus(`${getApiPrefixURL()}/svmx/a360/migration/getMigrationStatus`, jobId).then(res => {
                if (res !== null && res !== undefined) {
                  console.log('response - migration status', res);
                  const responseEntity = JSON.parse(res.entity);
                  const migrateStatusResponse = responseEntity.data;
                  console.log('migrateStatusResponse : ', migrateStatusResponse);
                  if (migrateStatusResponse !== null) {
                    const {
                      status,
                      message,
                      completedComponents,
                      totalComponents,
                      validationResult: {
                        validationMessageList = []
                      } = {}
                    } = migrateStatusResponse;
                    this.migrationStatus = status;
                    localThisState.progressPercent = completedComponents / totalComponents * 100;
                    localThisState.componentsValidationStatus = '(' + completedComponents + '/' + totalComponents + ')';
                    if (status === VALIDATION_FAILED) {
                      localThisState.isMigrationStatusModalOpen = true;
                      localThisState.migrateStatusData = validationMessageList;
                      localThisState.stopMigrationStatusTimer();
                      localThisState.isDeployedData = false;
                      localThisState.template.querySelector('button[data-my-id="deployButton"]').disabled = false;
                      localThisState.statusMessage = 'Please correct the below validation error(s) to continue with deployment.';
                    } else if (status === COMPLETED || status === MIGRATION_PARTIAL_SUCCESS) {
                      localThisState.statusMessage = status === 'Completed' ? 'Deployed source org data to the target org successfully.' : message;
                      localThisState.template.querySelector('div[data-my-id="toastMessageDiv"]').style.display = 'block';
                      localThisState.stopMigrationStatusTimer();
                      localThisState.isDeployedData = false;
                      localThisState.template.querySelector('button[data-my-id="deployButton"]').disabled = false;
                      setTimeout(() => {
                        localThisState.template.querySelector('div[data-my-id="toastMessageDiv"]').style.display = 'none';
                      }, 5000);
                    } else if (status === MIGRATION_FAILED || status === IMPORT_FAILED) {
                      this.template.querySelector('div[data-my-id="toastErrorMessageDiv"]').style.display = 'block';
                      this.statusMessage = message;
                      localThisState.stopMigrationStatusTimer();
                      localThisState.isDeployedData = false;
                      localThisState.template.querySelector('button[data-my-id="deployButton"]').disabled = false;
                      setTimeout(() => {
                        this.template.querySelector('div[data-my-id="toastErrorMessageDiv"]').style.display = 'none';
                      }, 5000);
                    }
                  }
                }
              }).catch(function (err) {
                localThisState.stopMigrationStatusTimer();
                console.log('Migrate status - Error', err);
              });
            }, 1000);
          } else {
            this.template.querySelector('div[data-my-id="toastErrorMessageDiv"]').style.display = 'block';
            this.statusMessage = message;
            localThisState.stopMigrationStatusTimer();
            localThisState.isDeployedData = false;
            localThisState.template.querySelector('button[data-my-id="deployButton"]').disabled = false;
            setTimeout(() => {
              this.template.querySelector('div[data-my-id="toastErrorMessageDiv"]').style.display = 'none';
            }, 5000);
          }
        }
      }).catch(function (err) {
        console.log('Migration failed - Error', err);
      }).finally(() => {
        console.log('data successfully migrated');
      });
    };
    this.overwriteMigrationData = (selectedRowsData, migrateStatusData) => {
      let preMigrationData = [];
      for (let index = 0; index < migrateStatusData.length; index++) {
        const {
          validationType
        } = migrateStatusData[index];
        if (validationType !== DUPLICATE_CONF) {
          preMigrationData.push(migrateStatusData[index]);
        }
      }
      if (preMigrationData.length > 0) {
        preMigrationData = this.getFilterOverwriteMigrationData(selectedRowsData, preMigrationData);
      } else {
        preMigrationData = selectedRowsData;
      }
      preMigrationData = preMigrationData.filter(element => {
        return element !== undefined;
      });
      return preMigrationData;
    };
    this.getFilterOverwriteMigrationData = (selectedRowsData, preMigrationData) => {
      let uniqueDeveloperNames = [];
      let copyOfSelectedRowsData = [...selectedRowsData];
      for (let i = 0; i < preMigrationData.length; i++) {
        const {
          developerName,
          parentDeveloperName
        } = preMigrationData[i];
        const parDeveloperName = parentDeveloperName !== undefined ? parentDeveloperName : developerName;
        uniqueDeveloperNames.push(parDeveloperName);
      }
      uniqueDeveloperNames = [...new Set(uniqueDeveloperNames)];
      for (let index = 0; index < copyOfSelectedRowsData.length; index++) {
        const {
          developerName
        } = copyOfSelectedRowsData[index];
        if (uniqueDeveloperNames.includes(developerName)) {
          delete copyOfSelectedRowsData[index];
        }
      }
      return copyOfSelectedRowsData;
    };
    this.handleConfirmMigration = () => {
      this.isMigrationStatusModalOpen = false;
      this.deploySourceOrgDataToTargetOrg(true);
    };
    this.handleConfirmMigrationStatus = event => {
      if (event.detail !== undefined && event.detail.checked) {
        this.template.querySelector('lightning-button[data-my-id="confirmButton"]').disabled = false;
      } else {
        this.template.querySelector('lightning-button[data-my-id="confirmButton"]').disabled = true;
      }
    };
    this.closeMigrationStatusModal = () => {
      this.isMigrationStatusModalOpen = false;
    };
    this.stopMigrationStatusTimer = () => {
      clearInterval(this.timer);
    };
    this.getFormattedRequest = selectedRowsData => {
      let formattedRequest = [];
      for (let i = 0; i < selectedRowsData.length; i++) {
        const {
          _children: levelOneChildrens
        } = selectedRowsData[i];
        if (levelOneChildrens !== undefined && levelOneChildrens.length > 0) {
          for (let j = 0; j < levelOneChildrens.length; j++) {
            const {
              _children: levelTwoChildrens
            } = levelOneChildrens[j];
            if (levelTwoChildrens !== undefined && levelTwoChildrens.length > 0) {
              formattedRequest.push(levelTwoChildrens);
            }
          }
          if (levelOneChildrens[0]._children === undefined) {
            formattedRequest.push(levelOneChildrens);
          }
        }
      }
      return formattedRequest;
    };
    this.getFlatArrayRequest = formattedRowsRequest => {
      return Array.prototype.concat.apply([], formattedRowsRequest);
    };
    this.closeToastMessage = () => {
      this.template.querySelector('div[data-my-id="toastMessageDiv"]').style.display = 'none';
    };
    this.closeToastErrorMessage = () => {
      this.template.querySelector('div[data-my-id="toastErrorMessageDiv"]').style.display = 'none';
    };
    this.addEventListener('clearqueuedlist', this.handleClearQueuedList.bind(this));
    this.addEventListener('removetargetrecord', this.handleRemoveTargetRecord.bind(this));
    this.addEventListener('showvalidatedeployprogressbar', this.showValidateDeployProgressbar.bind(this));
    this.addEventListener('hidevalidatedeployprogressbar', this.hideValidateDeployProgressbar.bind(this));
    this.addEventListener('updatesourcetablerows', this.updateSourceTableRows.bind(this));
    this.addEventListener('updatetargettable', this.handleUpdateTargetTableData.bind(this));
    this.addEventListener('filterconfigurations', this.handleFilterConfigurations.bind(this));
    this.addEventListener('exportconfigurations', this.handleExportConfigurations.bind(this));
    this.addEventListener('closeexportconfmodal', this.closeExportConfModal.bind(this));
    document.addEventListener('validationerror', this.handleValidationError.bind(this));
    document.addEventListener('validatedeploysessionexpire', this.handleValidateDeploySessionExpire.bind(this));
  }
  get options() {
    return [{
      label: 'Sandbox',
      value: SANDBOX
    }, {
      label: 'Production',
      value: PRODUCTION
    }];
  }
  get fileOption() {
    return [{
      label: 'Import from file',
      value: 'importFile'
    }];
  }
  orgMenuOptions() {
    return [{
      label: 'Disconnect',
      value: 'Disconnect'
    }, {
      label: 'Properties',
      value: 'Properties'
    }];
  }
  importFileMenuOptions() {
    return [{
      label: 'Back',
      value: 'Back'
    }];
  }
  renderedCallback() {
    const localThisState = this;
    let storedSourceSessionInfo = "";
    const sourceSessionInfo = getLocalStorage('sourceSessionInfo');
    if (sourceSessionInfo !== undefined && sourceSessionInfo !== null) {
      storedSourceSessionInfo = JSON.parse(sourceSessionInfo);
    }
    const sourceOrganizationInfo = getLocalStorage('sourceOrganizationInfo');
    const targetOrganizationInfo = getLocalStorage('targetOrganizationInfo');
    if (sourceOrganizationInfo !== undefined && sourceOrganizationInfo !== null && !localThisState.isSourceConfigExecuted && !localThisState.isLogout) {
      localThisState.isDataLoaded = true;
      localThisState.isSourceOrgLoggedIn = true;
      localThisState.isSourceOptionsEnabled = true;
      localThisState.disableTargetLoginCard = false;
      localThisState.sourceMenuOptions = this.orgMenuOptions();
      const parsedSourceOrgInfo = JSON.parse(sourceOrganizationInfo);
      localThisState.getOrgInfoDetails(parsedSourceOrgInfo, SOURCE);
      localThisState.sourceOrgUserInfoDetails = parsedSourceOrgInfo;
    }
    if (targetOrganizationInfo !== undefined && targetOrganizationInfo !== null && !localThisState.isSourceConfigExecuted && !localThisState.isLogout) {
      localThisState.isTargetOrgLoggedIn = true;
      localThisState.isTargetOptionsEnabled = true;
      if (sourceOrganizationInfo === undefined) {
        localThisState.isSourceConfigExecuted = true;
      }
      localThisState.targetMenuOptions = localThisState.orgMenuOptions();
      const parsedTargetOrgInfo = JSON.parse(targetOrganizationInfo);
      localThisState.getOrgInfoDetails(parsedTargetOrgInfo, TARGET);
      localThisState.targetOrgUserInfoDetails = parsedTargetOrgInfo;
    }
    if (storedSourceSessionInfo !== undefined && sourceOrganizationInfo !== undefined && !localThisState.isSourceConfigExecuted && !localThisState.isLogout) {
      localThisState.isSourceOrgLoggedIn = true;
      localThisState.isSourceConfigExecuted = true;
      localThisState.isSourceOrgDataLoaded = true;
      const formattedSforceSessionInfo = `{"acessToken":"${storedSourceSessionInfo.access_token}","serviceEndpoint":"${storedSourceSessionInfo.instance_url}/services/Soap/u/41.0/"}`;
      localThisState.getConfigurations(SOURCE, formattedSforceSessionInfo);
    }
    if (this.isExportBtnDisabled && this.template.querySelector('lightning-tab[data-my-id="configElementsTab"]')) {
      this.template.querySelector('lightning-tab[data-my-id="configElementsTab"]').classList.add('tab-height-upload__align');
    }
    if (this.isExportBtnDisabled && this.template.querySelector('lightning-tab[data-my-id="translationsTab"]')) {
      this.template.querySelector('lightning-tab[data-my-id="translationsTab"]').classList.remove('tab-height__align');
      this.template.querySelector('lightning-tab[data-my-id="translationsTab"]').classList.add('tab-height-upload__align');
    }
  }
  async handleFilesChange(event) {
    const files = event.detail;
    if (files.length > 0) {
      const file = {
        fileName: files[0].name,
        fileContent: await this.toBase64(files[0])
      };
      this.uploadedFileName = file.fileName;
      this.filesContent = file.fileContent;
    }
    this.handleDisplayConfigurations();
  }
  handleSelectedSourceGridRows(event) {
    let selectedRows = [];
    let {
      detail
    } = event;
    const {
      translationRows: translationRows,
      isTranslation = false
    } = detail;
    if (isTranslation) {
      detail = translationRows;
      if (this.template.querySelector('my-target-tabset')) {
        this.template.querySelector('my-target-tabset').updateValidateBtnStatus(true, false, this.translationLanguages);
      }
    } else {
      if (this.template.querySelector('my-target-tabset')) {
        this.template.querySelector('my-target-tabset').updateValidateBtnStatus(false, false, []);
      }
    }
    if (detail && detail.length > 0) {
      selectedRows = [...selectedRows, ...detail];
      this.targetTreeGridData = this.targetTreeGridData ? [...this.targetTreeGridData, ...detail] : detail;
    }
    this.targetTreeGridData = this.targetTreeGridData.filter(o1 => selectedRows.some(o2 => o1.id === o2.id));
    this.targetTreeGridData = this.targetTreeGridData ? getUniqueObject(this.targetTreeGridData.flat()) : detail;
    this.preSelectedRowsIds = this.getPreSelectedRows();
    const formattedDetails = this.formattedDetails(this.targetTreeGridData);
    if (this.template.querySelector('my-target-tabset')) {
      this.template.querySelector('my-target-tabset').updateQueuedCount(formattedDetails, isTranslation);
    }
  }
}
_registerDecorators(ConfigMigration, {
  fields: ["isDataLoaded", "isTargetOrgLoggedIn", "isSourceOrgDataLoaded", "isTargetOrgDataLoaded", "isOrgInfoModalOpen", "isTargetOrgInfoModalOpen", "isFilterModalOpen", "isConfirmModalOpen", "isDeployedData", "isMigrationStatusModalOpen", "migrationsStatusTitle", "migrationStatusData", "isSessionExpiredModalOpen", "isLogout", "configurations", "orgType", "expandedRow", "originalConfigurations", "statusMessage", "envType", "targetTreeGridData", "isSourceAPIExecuted", "isTargetAPIExecuted", "timer", "migrateStatusData", "columns", "progressPercent", "migrationStatus", "componentsValidationStatus", "isDataTableView", "isDataTableFilterPopup", "isDataGridFilterPopup", "sourceUsername", "sourceOrganizationId", "sourceOrganizationName", "sourceOrganizationType", "sourceOrgUserEmail", "sourceOrgUserType", "sourcePackageVersion", "targetUsername", "targetOrganizationId", "targetOrganizationName", "targetOrganizationType", "targetOrgUserEmail", "targetOrgUserType", "targetPackageVersion", "isSourceConfigExecuted", "isSourceOrgLoggedIn", "isSearchEnabled", "isConfSelectedToExport", "preSelectedRowsIds", "beforeSearchRows", "searchConfigName", "searchDeveloperName", "searchCompType", "searchSubType", "searchValue", "filesContent", "uploadedFileName", "isImportFileEnabled", "importFileUniqueID", "isSourceOptionsEnabled", "isTargetOptionsEnabled", "disableTargetLoginCard", "queuedCount", "deployedCount", "errorCount", "orgUserDetails", "sourceOrgUserInfoDetails", "targetOrgUserInfoDetails", "isExportBtnDisabled", "value", "sourceMenuOptions", "targetMenuOptions", "showValidateDeploySpinner", "isSourceOrgLogout", "logoutModalHeader", "logoutModalMessage", "logoutModalConfirmMessage", "filterConfigs", "translations", "isConfExported", "isConfSelectedToExport", "isTabChange", "warningText", "selectedType", "previousTabValue", "activeTabValue", "configElementsTabTitle", "translationsTabTitle", "translationLanguages", "isTargetPackageVersionLower", "showValidateDeployProgressbar", "hideValidateDeployProgressbar", "handleValidationError", "handleMigrateError", "handleMigrateComplete", "showErrorModal", "handleClearQueuedList", "handleRemoveTargetRecord", "handleSourcePropertiesModal", "handleTargetPropertiesModal", "formatOrgUserInfo", "handleFileOptionChange", "handleChange", "getOrgInfoDetails", "hanldeSelectedview", "getSalesforceSession", "getOAuthCallbackResponse", "getConfigurations", "formatTranslationConfigurations", "formatConfigurations", "formattedConfigurations", "logoutSourceOrg", "cancelSourceOrgDisconnect", "closePackageVersionWarnModal", "handleSourceOrgDisconnect", "logoutTargetOrg", "openSourceOrgUserInfoModal", "closeSourceOrgUserInfoModal", "openTargetOrgUserInfoModal", "closeTargetOrgUserInfoModal", "closeSourceOrgLoginModal", "toBase64", "handleDisplayConfigurations", "getFormattedResponse", "formatDepResponseForUploadFile", "handleBackButton", "logoutFileTargetOrg", "clearUploadFileData", "logoutOrg", "handleSearch", "handleUpdateTargetTableData", "handleFilterConfigurations", "handleSourceDataTableSearch", "getPreSelectedRows", "updateSourceTableRows", "handleSourceTreeGridSearch", "getFilteredData", "getSecondLevelFilteredData", "applySearchFilterOnDataTable", "applySearchFilterData", "handleFilterData", "getTranslationIds", "handleActive", "handleExportConfigurations", "closeExportConfModal", "handleWarningModal", "cancelWarningModal", "formattedDetails", "confirmDeploy", "closeConfirmModal", "handleSessionExpire", "handleValidateDeploySessionExpire", "deploySourceOrgDataToTargetOrg", "overwriteMigrationData", "getFilterOverwriteMigrationData", "handleConfirmMigration", "handleConfirmMigrationStatus", "closeMigrationStatusModal", "stopMigrationStatusTimer", "getFormattedRequest", "getFlatArrayRequest", "closeToastMessage", "closeToastErrorMessage"]
});
export default _registerComponent(ConfigMigration, {
  tmpl: _tmpl
});